import TransferProcessingScreen from 'features/feeBasedInstantTransfer/screens/TransferProcessing/TransferProcessingScreen';

export default function TransferProcessingPage() {
  return <TransferProcessingScreen />;
}
